<script setup>
import { close_button_ui_styles, modal_ui_styles } from '~~/shared/utilities/ui'

const { $bus } = useNuxtApp();

const open = defineModel('open')
const router = useRouter()
const route = useRoute()

watch(open, (val) => {
    if (val) { 
        $bus.emit('drawer-open'); 
    }
    else {
        $bus.emit('drawer-close');
        const currentQuery = { ...route.query };
        delete currentQuery.modal;
        delete currentQuery.action;
        router.replace({ query: currentQuery });
    }
})
</script>

<template>
    <UModal v-model:open="open" title="Braindate" description="Connect with other attendees through a braindate." :ui="modal_ui_styles" :dismissable="false" :close="close_button_ui_styles">
        <template #body>
            <FragmentsBraindate />
        </template>
    </UModal>
</template>

<style lang="scss">
    [data-dismissable-layer] .braindate-modal {
        padding: 3rem 0 4.5rem 0;
    }
</style>